import { useEffect, useState } from 'react';
import { Modal, Platform, Pressable, Text, View } from 'react-native';
import { aplicarAgora, baixarApk, useAtualizacao } from '../lib/atualizacoes';
import { C } from './theme';
import { t } from '../lib/i18n';

const COR = '#8B5CF6';
// "Depois" vale até a próxima vez que o app abrir (ou até chegar uma atualização mais nova)
const dispensados = new Set<string>();

/** Site: compara o pacote carregado com o publicado e avisa quando há versão nova (a cada 30 minutos). */
function useSiteNovo() {
  const [novo, setNovo] = useState(false);
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return;
    const atual = [...document.querySelectorAll('script[src]')].map(s => (s as HTMLScriptElement).src.split('/').pop()).find(x => x?.includes('entry')) ?? '';
    if (!atual) return;
    const ver = async () => {
      try {
        const html = await (await fetch(`/?v=${Date.now()}`, { cache: 'no-store' })).text();
        if (!html.includes(atual)) setNovo(true);
      } catch { /* sem internet */ }
    };
    const i = setInterval(ver, 30 * 60 * 1000);
    const vis = () => { if (document.visibilityState === 'visible') ver(); };
    document.addEventListener('visibilitychange', vis);
    return () => { clearInterval(i); document.removeEventListener('visibilitychange', vis); };
  }, []);
  return novo;
}

/** Janela na tela quando há atualização: além do aviso no Planner, para ninguém deixar passar. */
export function AtualizacaoPopup() {
  const a = useAtualizacao();
  const site = useSiteNovo();
  const [, re] = useState(0);
  const chave = a.ota === 'pronta' ? 'ota' : a.apk ? `apk:${a.apk.versao}` : site ? 'site' : '';
  if (!chave || dispensados.has(chave)) return null;
  const apk = chave.startsWith('apk');
  const depois = () => { dispensados.add(chave); re(x => x + 1); };
  const agir = () => { dispensados.add(chave); re(x => x + 1); if (chave === 'site') window.location.reload(); else if (apk) baixarApk(); else aplicarAgora(); };
  return (
    <Modal visible transparent animationType="fade" onRequestClose={depois}>
      <View style={{ flex: 1, backgroundColor: C.overlay, justifyContent: 'center', padding: 24 }}>
        <View style={{ backgroundColor: C.card, borderRadius: 22, padding: 22, gap: 12, maxWidth: 440, width: '100%', alignSelf: 'center', borderWidth: 1, borderColor: COR }}>
          <Text style={{ fontSize: 44, textAlign: 'center' }}>{apk ? '📲' : '✨'}</Text>
          <Text style={{ color: C.text, fontSize: 20, fontWeight: '800', textAlign: 'center' }}>
            {apk ? t('Versão {versao} disponível', { versao: a.apk!.versao }) : t('Atualização pronta')}
          </Text>
          <Text style={{ color: C.sub, textAlign: 'center' }}>
            {apk ? (a.apk!.notas || t('Toque para baixar e instalar por cima. Seus dados continuam.'))
              : chave === 'site' ? t('Há uma versão nova do My Planner Web. Recarregue para usar.') : t('Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.')}
          </Text>
          <Pressable onPress={agir} style={{ backgroundColor: COR, borderRadius: 14, padding: 14, alignItems: 'center' }}>
            <Text style={{ color: '#fff', fontWeight: '800', fontSize: 16 }}>{apk ? t('Baixar agora') : t('Atualizar agora')}</Text>
          </Pressable>
          <Pressable onPress={depois} style={{ padding: 8, alignItems: 'center' }}><Text style={{ color: C.sub }}>{t('Depois')}</Text></Pressable>
        </View>
      </View>
    </Modal>
  );
}
